import { render, staticRenderFns } from "./Application.vue?vue&type=template&id=bec01bcc&scoped=true&"
import script from "./Application.vue?vue&type=script&lang=js&"
export * from "./Application.vue?vue&type=script&lang=js&"
import style0 from "./Application.vue?vue&type=style&index=0&id=bec01bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec01bcc",
  null
  
)

export default component.exports